import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, {
    key: `cart-drawer-${$data.componentKey}`,
    to: "#cart-drawer-portal"
  }, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps($options.cartData)))
  ]))
}